import { nanoid } from 'nanoid';
import { ANALYTICS } from './constants';
import { ENV, AnalyticsConfigType } from './types';

// Get Analytics ID from session storage or create new UUID
export const getAnalyticsIdentifier = (): string => {
  let analyticsIdentifier = sessionStorage.getItem(ANALYTICS.SESSION_ID);
  if (analyticsIdentifier) return analyticsIdentifier;

  analyticsIdentifier = nanoid();
  sessionStorage.setItem(ANALYTICS.SESSION_ID, analyticsIdentifier);
  return analyticsIdentifier;
};

export const getAnalyticsConfig = (): AnalyticsConfigType => {
  return {
    track: ANALYTICS.TEAM,
    projectName: ANALYTICS.PROJECT,
    environment: (process.env.REACT_APP_ANALYTICS_ENV as ENV) || 'dev',
    payloadMetaAttributes: {
      [ANALYTICS.SESSION_ID]: getAnalyticsIdentifier(),
    },
  };
};
